import React, { useEffect, useRef, useState } from 'react';
import styles from './Header.module.scss';
import CircularMenu, { MenuItem } from '../CircularMenu/CircularMenu.tsx';

interface IHeaderProps {
    home?: boolean;
}

const DEFAULT_NAV_ITEMS: MenuItem[] = [
    { title: 'Инфраструктура', href: '/#Infrasctructure' },
    { title: 'Услуги', href: '/#Services' },
    { title: 'Отзывы', href: '/#Reveiws' },
    { title: 'Условия', href: '/#Contacts' },
    { title: 'Апартаменты', href: '/#Aparts' },
    { title: 'Главная', href: '/' },
    { title: 'Контакты', href: '/#Contacts' },
    { title: 'Политика', href: '/#Politics' },
];

const Header: React.FC<IHeaderProps> = ({ home }) => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const [navItems, setNavItems] = useState<MenuItem[]>(DEFAULT_NAV_ITEMS);

    // Реф для отслеживания блока .center
    const centerRef = useRef<HTMLDivElement>(null);

    // Формируем ссылки после монтирования
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const origin = window.location.origin;
            setNavItems([
                { title: 'Инфраструктура', href: `${origin}/#Infrasctructure` },
                { title: 'Услуги', href: `${origin}/#Services` },
                { title: 'Отзывы', href: `${origin}/#Reveiws` },
                { title: 'Условия', href: `${origin}/#Contacts` },
                { title: 'Апартаменты', href: `${origin}/#Aparts` },
                { title: 'Главная', href: `${origin}` },
                { title: 'Контакты', href: `${origin}/#Contacts` },
                { title: 'Политика', href: `${origin}/#Politics` },
            ]);
        }
    }, []);

    // Скролл наверх и блокировка / разблокировка скролла
    useEffect(() => {
        if (isOpenMenu) {
            // 1. Прокручиваем страницу в самый верх
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant', // 'instant' или 'auto' для мгновенной прокрутки перед блокировкой
            });

            // 2. Блокируем скролл
            document.body.style.overflow = 'hidden';
        } else {
            // Разблокируем скролл при закрытии
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpenMenu]);

    // Закрываем меню при клике вне области centerRef
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            if (
                centerRef.current &&
                !centerRef.current.contains(event.target as Node)
            ) {
                setIsOpenMenu(false);
            }
        };

        if (isOpenMenu) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpenMenu]);

    // Закрываем меню при скролле более 200px (на случай внешнего скролла)
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsOpenMenu(false);
            }
        };

        if (isOpenMenu) {
            window.addEventListener('scroll', handleScroll, { passive: true });
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isOpenMenu]);

    return (
        <div className={`${styles.Header} ${home ? styles.Home : ''}`}>
            <div className={styles.left}>
                <a href={typeof window !== 'undefined' ? window.location.origin : '/'}>
                    <img className={styles.logo} src="/images/logo_black.svg" alt="Logo" />
                </a>
            </div>

            <div className={styles.center} ref={centerRef}>
                <button
                    className={`${styles.menuButton} ${isOpenMenu ? styles.opened : ''}`}
                    onClick={() => setIsOpenMenu((prev) => !prev)}
                />
                <div className={styles.menu}>
                    {isOpenMenu && (
                        <CircularMenu
                            items={navItems}
                            onClose={() => setIsOpenMenu(false)}
                            radius={200}
                            device={3}
                            ANGLES={[0, 35, 90, 145, 180, 215, 270, 325]}
                            theme="Black"
                        />
                    )}
                </div>
            </div>

            <div className={styles.right}>
                <a className={styles.number} href="tel:+79299023710">
                    +7 929 902 37 10
                </a>
                <a
                    className={styles.tg}
                    href="https://t.me/cozzyaparts"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src="/images/tg_black.svg" alt="Telegram" />
                </a>
            </div>
        </div>
    );
};

export default Header;